// useTimeOfDay — returns the current time-of-day bucket and re-evaluates
// on the minute. The 3am Mode (Phase 19) and morning/evening surfaces
// in Today key off this so the home screen behaves differently at
// different hours without a separate route.
//
// Buckets (local time):
//   night   = 23:00–04:59  (3am Mode lite)
//   morning = 05:00–11:59  (yesterday's pledge surface)
//   day     = 12:00–17:59  (quick-log focus)
//   evening = 18:00–22:59  (check-in CTA promoted)

import { useEffect, useState } from 'react';

export type TimeOfDay = 'morning' | 'day' | 'evening' | 'night';

export function periodForHour(h: number): TimeOfDay {
  if (h >= 23 || h < 5) return 'night';
  if (h < 12) return 'morning';
  if (h < 18) return 'day';
  return 'evening';
}

export function useTimeOfDay(): TimeOfDay {
  const [tod, setTod] = useState<TimeOfDay>(() => periodForHour(new Date().getHours()));
  useEffect(() => {
    const id = window.setInterval(() => {
      setTod(periodForHour(new Date().getHours()));
    }, 60_000);
    return () => window.clearInterval(id);
  }, []);
  return tod;
}
